"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.responseReporter = void 0;
var auth_suite_fetch_1 = require("../../auth-suite-fetch");
var requestRoute = "guards/errors";
var reportInvalidResponse = function (payload) {
    var body = JSON.stringify(payload);
    return auth_suite_fetch_1.authSuiteFetchWithAuthorization.post({
        body: body,
        path: requestRoute,
    });
};
var report = function (payload) {
    return reportInvalidResponse(payload);
};
exports.responseReporter = {
    report: report,
};
